// Create style for preview
export const createPreviewStyle = ({
  y,
  x,
  show,
  color,
  shadowX,
  shadowY,
  fontSize,
  alignment,
  hasShadow,
  shadowBlur,
  borderColor,
  shadowColor,
  borderThickness,
  xWithTextWidth,
}) => ({
  color,
  top: `${y >= 0 ? parseInt(y) : 0}%`,
  left: `${x >= 0 ? parseInt(x) : 0}%`,
  position: "absolute",
  textAlign: alignment,
  fontSize: `${fontSize}px`,
  display: show ? "block" : "none",
  border:
    borderThickness > 0 ? `${borderThickness}px solid ${borderColor}` : "none",
  textShadow: hasShadow
    ? `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowColor}`
    : "none",
});

// Fill form for gift card design
export function cardDesignFillFormWithStyles(item) {
  if (!item) return {};
  const {
    show,
    color,
    shadow,
    border,
    fontSize,
    alignment,
    hasShadow,
    disclaimer,
    xPercentage,
    yPercentage,
  } = item;

  return {
    x: xPercentage >= 0 ? parseInt(xPercentage) : 0,
    xWithTextWidth: xPercentage >= 0 ? parseInt(xPercentage) : 0,
    y: yPercentage >= 0 ? parseInt(yPercentage) : 0,
    show,
    color,
    fontSize,
    alignment,
    hasShadow,
    content: "test",
    shadowX: shadow?.x,
    shadowY: shadow?.y,
    disclaimer: disclaimer || 0,
    shadowBlur: shadow?.blur,
    borderColor: border?.color,
    shadowColor: shadow?.color,
    borderThickness: border?.thickness,
  };
}
